// eslint-disable-next-line import/prefer-default-export
export const exitPopupTemplate1 = `
<div class="section-what-we-do">
  <div class="what-we-do">
    <div class="what-we-do__content">
      <h2>what can
        <span>WE DO</span>
        <strong>for you?</strong>
      </h2>
      <p>Tell us what kind of service you need</p>
    </div>
    <div class="what-we-do__links">
      <a href="/dashboard/orders/create/?orderServiceTypeId=45" class="what-we-do__links__item what-we-do__links__item--stem">I need help with my STEM project</a>
      <a href="/dashboard/orders/create/?orderServiceTypeId=37" class="what-we-do__links__item what-we-do__links__item--writing">I need help with my writing task</a>
    </div>
    <div class="what-we-do__img">
    <img src="/images/img_girl.svg" alt="">
    </div>
  </div>
</div>`;
